import React from 'react';
import { debounce } from '@mui/material';

function useDebouncedEffect(
  effect: Function,
  deps: React.DependencyList,
  delay = 100,
) {
  React.useEffect(() => {
    const handler = debounce(() => {
      effect();
    }, delay);

    handler();

    return handler.clear;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export default useDebouncedEffect;
